(function(){
  document.querySelectorAll('.qty').forEach(function(qty){
    var input = qty.querySelector('input[name="quantity"]');
    var display = qty.querySelector('[data-qty-display]');
    qty.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        var delta = b.dataset.qty === '+' ? 1 : -1;
        var v = Math.max(1, parseInt(input.value || 1, 10) + delta);
        input.value = v;
        if (display) display.textContent = v;
      });
    });
  });
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(){
      setTimeout(function(){
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
          document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
        }).catch(function(){});
      }, 800);
    });
  });
})();


// === PDP carousel ===
document.querySelectorAll('[data-gallery]').forEach(function(gallery) {
  var track = gallery.querySelector('.gallery-track');
  var prev = gallery.querySelector('.gallery-prev');
  var next = gallery.querySelector('.gallery-next');
  var counter = gallery.querySelector('[data-counter]');
  var thumbs = gallery.querySelectorAll('.gallery-thumb');
  if (!track) return;

  function slideWidth() {
    var s = track.querySelector('.gallery-slide');
    return s ? s.offsetWidth : 0;
  }
  function current() {
    var w = slideWidth();
    return w ? Math.round(track.scrollLeft / w) : 0;
  }
  function update() {
    var cur = current();
    var total = track.children.length;
    if (counter) counter.textContent = (cur + 1) + ' / ' + total;
    thumbs.forEach(function(t, i) {
      t.classList.toggle('active', i === cur);
    });
  }
  function go(idx) {
    var w = slideWidth();
    track.scrollTo({ left: idx * w, behavior: 'smooth' });
  }

  if (prev) prev.addEventListener('click', function() {
    go(Math.max(0, current() - 1));
  });
  if (next) next.addEventListener('click', function() {
    go(Math.min(track.children.length - 1, current() + 1));
  });
  thumbs.forEach(function(t, i) {
    t.addEventListener('click', function() { go(i); });
  });
  track.addEventListener('scroll', update, { passive: true });
  update();
});


// === Stack the Kit — Fisher-Yates shuffle, pick N random cards ===
document.querySelectorAll('[data-stack-the-kit]').forEach(function(grid) {
  var limit = parseInt(grid.dataset.limit || 3, 10);
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.stack-card'));
  if (cards.length === 0) return;
  // Shuffle
  for (var i = cards.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
  }
  // Show first N (in shuffled order), remove rest
  cards.forEach(function(card, idx) {
    if (idx < limit) {
      card.removeAttribute('hidden');
      grid.appendChild(card);
    } else {
      card.remove();
    }
  });
});


// === Mobile menu toggle ===
document.querySelectorAll('[data-nav-toggle]').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    var isHidden = menu.hasAttribute('hidden');
    if (isHidden) {
      menu.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'Close menu');
      document.documentElement.style.overflow = 'hidden';
    } else {
      menu.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open menu');
      document.documentElement.style.overflow = '';
    }
  });
});

// Close mobile menu when a link is clicked
document.querySelectorAll('[data-mobile-menu] a').forEach(function(a) {
  a.addEventListener('click', function() {
    var menu = document.querySelector('[data-mobile-menu]');
    var btn = document.querySelector('[data-nav-toggle]');
    if (menu) menu.setAttribute('hidden', '');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  });
});

// Mobile sticky nav (after the announcement bar scrolls past)
(function() {
  var nav = document.querySelector('.nav');
  var topbar = document.querySelector('.topbar');
  if (!nav) return;

  function check() {
    if (!window.matchMedia('(max-width: 880px)').matches) {
      nav.classList.remove('nav-scrolled');
      document.body.style.paddingTop = '';
      return;
    }
    var topbarHeight = topbar ? topbar.offsetHeight : 0;
    var navHeight = nav.offsetHeight || 72;
    if (window.scrollY >= topbarHeight) {
      if (!nav.classList.contains('nav-scrolled')) {
        nav.classList.add('nav-scrolled');
        document.body.style.paddingTop = navHeight + 'px';
      }
    } else {
      if (nav.classList.contains('nav-scrolled')) {
        nav.classList.remove('nav-scrolled');
        document.body.style.paddingTop = '';
      }
    }
  }

  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check, { passive: true });
  check();
})();

// Story timeline: fade in as each row scrolls into view
(function() {
  var rows = document.querySelectorAll('.story-row');
  if (!rows.length) return;

  // Fallback for old browsers
  if (!('IntersectionObserver' in window)) {
    rows.forEach(function(r) { r.classList.add('in-view'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -10% 0px'
  });

  rows.forEach(function(row) { observer.observe(row); });
})();

// === Homepage scroll animations ===
(function() {
  if (!('IntersectionObserver' in window)) return;

  // 2. Pillars stagger
  var pillars = document.querySelectorAll('.pillars');
  if (pillars.length) {
    var pillarObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          pillarObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    pillars.forEach(function(p) { pillarObserver.observe(p); });
  }

  // 3. Stats count-up
  function animateCount(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/^(£?)([\d.]+)(.*)$/);
    if (!match) return;
    var prefix = match[1];
    var target = parseFloat(match[2]);
    var suffix = match[3];
    if (isNaN(target) || target === 0) return;

    var duration = 1500;
    var start = null;
    var decimals = match[2].indexOf('.') !== -1 ? 1 : 0;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = (target * eased).toFixed(decimals);
      el.textContent = prefix + current + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  var statNums = document.querySelectorAll('.stats .num');
  if (statNums.length) {
    var statsObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          statsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    statNums.forEach(function(n) { statsObserver.observe(n); });
  }

  // 4. Generic section reveal — apply to Shopify sections except those that animate themselves
  var skipSelectors = '.hero, .marquee, .pillars, .stats, .topbar, .nav, footer';
  document.querySelectorAll('.shopify-section').forEach(function(section) {
    if (section.querySelector(skipSelectors)) return;
    if (section.matches(skipSelectors)) return;
    section.classList.add('reveal-on-scroll');
  });

  var sections = document.querySelectorAll('.reveal-on-scroll');
  if (sections.length) {
    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          sectionObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    sections.forEach(function(s) { sectionObserver.observe(s); });
  }
})();